/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;



//////////////////
// WEBPACK FOOTER
// (webpack)/buildin/amd-options.js
// module id = /opt/atlassian/pipelines/agent/build/node_modules/webpack/buildin/amd-options.js
// module chunks = core